import React, { useContext } from 'react'
import { CollapseGroup } from 'app/components/accordion/collapse-group'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { reportContext, useExport } from '../contexts'
import { useReport } from '../hooks'
import { AllFilesTypes, ExtractedFile } from '../types'
import { humanFileSize } from '../helpers'

export function FilesCollapseGroup({
  data,
  filesType,
  selected,
}: {
  data: { [hash: string]: JSX.Element }
  filesType: AllFilesTypes
  selected?: string
}) {
  const { _t } = useTypedTranslation()
  const { exporting } = useExport()
  const { reportId } = useReport()
  const reportsWrapper = useContext(reportContext)
  const extractedFiles: ExtractedFile[] = reportsWrapper.getExtractedFiles(reportId, filesType) ?? []
  let openedKey = selected ?? ''

  const dataItems = extractedFiles.flatMap((file) => {
    const sha256 = file.hashes.sha256
    if (typeof data[sha256] === 'undefined') {
      return []
    }

    const header = (
      <>
        <div className="ellipsis">{file.name}</div>
        <div className="ellipsis">{file.description || '-'}</div>
        <div className="ellipsis">{file.mediaType}</div>
        <div className="ellipsis">{humanFileSize(parseInt(file.size))}</div>
      </>
    )

    const body = <div className="file-data-container">{data[sha256]}</div>

    return { header, body }
  })

  if (selected) {
    const visibleFiles = extractedFiles.filter((f) => data[f.hashes.sha256] !== undefined)
    const idx = visibleFiles.findIndex((f) => f.hashes.sha256 === selected)
    if (idx >= 0) {
      openedKey = String(idx)
    }
  }

  const generalHeader = (
    <>
      <div>{_t('file-name')}</div>
      <div>{_t('file-magic-description')}</div>
      <div>{_t('media-type')}</div>
      <div>{_t('size')}</div>
    </>
  )

  return (
    <CollapseGroup
      items={dataItems}
      className="table-accordion files-accordion"
      header={generalHeader}
      exporting={exporting}
      selected={openedKey}
    />
  )
}
